import { getEntryDayKey } from "../../../../../utils/tenantDate";
/**
 * Data Processing Helpers for CardBody
 * Functions for grouping and processing timer data
 */

/**
 * Format date string to YYYY-MM-DD format
 * @param {string} dateString - Date string to format
 * @returns {string|null} Formatted date or null
 */
const formatDate = (entry) => {
  if (!entry) {
    return null;
  }
  return getEntryDayKey(entry);
};

/**
 * Group and sum durations for timer entries
 * Groups entries by task, project, tag, and date, then sums their durations
 * @param {Array} data - Array of timer entry objects
 * @returns {Array} Grouped and aggregated timer entries
 */
export const groupAndSumDurations = (data) => {
  const groupedData = [];
  let currentGroup = null;
  let totalDuration = 0;
  let totalHr = 0;
  let totalMin = 0;
  let totalSec = 0;

  data.sort((a, b) => {
    if (a.task !== b.task) return a.task.localeCompare(b.task);
    if (a?.project?._id !== b?.project?._id)
      return a?.project?._id.localeCompare(b?.project?._id);
    if (a.tag && b.tag && a.tag?._id !== b.tag?._id)
      return a.tag?._id.localeCompare(b.tag?._id);
    return 0;
  });

  data.forEach((row) => {
    if (
      currentGroup &&
      currentGroup.user.trim() === row.user.trim() &&
      currentGroup.task.trim() === row.task.trim() &&
      currentGroup.project._id === row.project._id &&
      currentGroup.tag?._id === row.tag?._id &&
      formatDate(currentGroup) === formatDate(row)
    ) {
      // If the current row belongs to the same group, update the duration
      totalDuration += row.duration;
      totalHr += row.hr;
      totalMin += row.min;
      totalSec += row.sec;
      // Update startTime and endTime within the group
      if (row.startTime < currentGroup.startTime) {
        currentGroup.startTime = row.startTime;
      }
      if (row.endTime > currentGroup.endTime) {
        currentGroup.endTime = row.endTime;
      }
      currentGroup.entries.push(row);
    } else {
      // If the row starts a new group, push the previous group (if any) and start a new one
      if (currentGroup) {
        currentGroup.totalDuration = totalDuration;
        currentGroup.totalHr = totalHr;
        currentGroup.totalMin = totalMin;
        currentGroup.totalSec = totalSec;
        groupedData.push(currentGroup);
      }
      // Start a new group
      currentGroup = {
        _id: row._id,
        user: row.user,
        task: row.task,
        project: row.project,
        sprint: row.sprint,
        tag: row.tag,
        date: row.date,
        startTime: row.startTime,
        endTime: row.endTime,
        totalHr: row.hr,
        totalMin: row.min,
        totalSec: row.sec,
        totalDuration: row.duration,
        billable: row.billable,
        client: row.client,
        clientId: row.clientId,
        // Carried so the group renders and groups by the logger's day and zone,
        // exactly as the individual row would.
        localDate: row.localDate,
        localZone: row.localZone,
        entries: [row],
      };
      totalHr = row.hr;
      totalMin = row.min;
      totalSec = row.sec;
      totalDuration = row.duration;
    }
  });

  // Push the last group (if any)
  if (currentGroup) {
    currentGroup.totalDuration = totalDuration;
    currentGroup.totalHr = totalHr;
    currentGroup.totalMin = totalMin;
    currentGroup.totalSec = totalSec;
    groupedData.push(currentGroup);
  }

  groupedData.sort((a, b) => {
    return new Date(a.date) - new Date(b.date);
  });
  return groupedData;
};
